import { useMemo } from 'react';
const TODAY = new Date(new Date().setHours(0, 0, 0, 0));
export function useMentorshipDefaultValues() {
    const defaultValues = useMemo(() => ({
        classes: [],
        mediaId: null,
        imageId: null,
        coverImageId: null,
        cover: null,
        date: TODAY,
        startTime: '12:00',
        endTime: '13:00'
    }), []);
    return defaultValues;
}
